import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import SimpleCard from '../../../../components/SimpleCard';

export default function PointOfContact({ event }) {
  const { id, venue } = event;
  if (!id) return false;

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={8}>
        <SimpleCard>
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            <Typography variant="h6" fontWeight="bold" display="inline">
              Point of Contact:{' '}
            </Typography>
            <Typography variant="h7" marginTop={0} display="inline">
              Who will be the venue at this event?
            </Typography>
          </div>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1, flexDirection: 'column' }}>
              <Typography>Name:</Typography>
            </div>
            <div style={{ flex: 6, flexDirection: 'column' }}>
              <Typography color="#0997BA"> {venue?.contact_name}</Typography>
            </div>
          </div>
        </SimpleCard>
      </Grid>
    </Grid>
  );
}

PointOfContact.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
};
